import { render, staticRenderFns } from "./roleApplyCheckRecord.vue?vue&type=template&id=1b791f0a&scoped=true"
import script from "./roleApplyCheckRecord.vue?vue&type=script&lang=js"
export * from "./roleApplyCheckRecord.vue?vue&type=script&lang=js"
import style0 from "./roleApplyCheckRecord.vue?vue&type=style&index=0&id=1b791f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b791f0a",
  null
  
)

export default component.exports